import { render, staticRenderFns } from "./FormPageEventOrganizer.vue?vue&type=template&id=6641f77d&"
import script from "./FormPageEventOrganizer.vue?vue&type=script&lang=js&"
export * from "./FormPageEventOrganizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6641f77d')) {
      api.createRecord('6641f77d', component.options)
    } else {
      api.reload('6641f77d', component.options)
    }
    module.hot.accept("./FormPageEventOrganizer.vue?vue&type=template&id=6641f77d&", function () {
      api.rerender('6641f77d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/eventOrganizer/form/FormPageEventOrganizer.vue"
export default component.exports